import type { DataItem as DetailedJobQueriesTableDataItem } from '@/components/tables/DetailedJobQueriesTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  message: openapi.JobMessageOpenapi,
): DetailedJobQueriesTableDataItem {
  return {
    id: message.message_id,
    sender: getStrCell(message.respond_to || message.sender),
    message: getStrCell(message.msgtext),
    timeAndDate: message.sent,
    isPrivate: !!message.is_private,
  };
}
